module.exports = __webpack_public_path__ + "img/Earl_Blumenauer.29fec884.jpg";